export const E_CATALOGUE_ROOT_ELEMENT_ID = 'catalogue-ipaper-root';

// This might be outdated after recent changes - TODO
export const isECatalogue = () => Boolean(document.getElementById(E_CATALOGUE_ROOT_ELEMENT_ID));
